// import axios from 'axios'
// state
const state = {
  gisDataByCategories: [
    {
      value: 'weather',
      label: 'Meteorología',
      layer: null,
      geojson: null,
      show: true,
      load: false
    },
    {
      value: 'airQuality',
      label: 'Calidad de Aire',
      layer: null,
      geojson: null,
      show: false,
      load: false
    },
    {
      value: 'aeroAllergen',
      label: 'Alergenos',
      layer: null,
      geojson: null,
      show: false,
      load: false
    },
    {
      value: 'noiseLevel',
      label: 'Nivel de Ruido',
      layer: null,
      geojson: null,
      show: false,
      load: false
    }
  ],
  categoriesDisabled: true,
  kpisIntervalStations: null,
  chartsIntervalStations: null,
  kpisAmbientalMeteo: null
}

// getters
const getters = {
  getKpisIntervalStationsData (state) {
    return state.kpisIntervalStations
  },
  getCategoriesDisabled (state) {
    return state.categoriesDisabled
  },
  getChartsIntervalStationsData (state) {
    return state.chartsIntervalStations
  },
  getCategoriesStationsData (state) {
    return state.gisDataByCategories
  },
  getKpisAmbientalMeteoData (state) {
    return state.kpisAmbientalMeteo
  }
}

// actions
const actions = {
  // Update interval Stations
  updateKpisIntervalStations ({ commit, state }, data) {
    commit('UPDATE_KPIS_INTERVAL_STATIONS', data)
  },
  // Update chart interval Stations
  updateChartsIntervalStations ({ commit, state }, data) {
    commit('UPDATE_CHARTS_INTERVAL_STATIONS', data)
  },
  // Update Categories Stations
  updateCategoryStation ({ commit, state }, data) {
    commit('UPDATE_CATEGORY_STATION', data)
  },
  // Update Categories Stations
  updateCategoriesStations ({ commit, state }, data) {
    commit('UPDATE_CATEGORIES_STATIONS', data)
  },
  // Update Categories Disabled
  updateCategoryDisabled ({ commit, state }, data) {
    commit('UPDATE_CATEGORY_DISABLED', data)
  },
  // Update data Kpis Viewer Ambiental and Meteo
  updateKpisViewerAmbientalMeteo ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/interval',
      data: null,
      params: {
        product: data.product,
        type: data.type,
        interval: data.interval,
        intervalUnit: data.intervalUnit,
        city: 'ES LPA'
      },
      mutation: 'UPDATE_KPIS_AMBIENTAL_METEO'
    }
    store.dispatch('callService', dataService)
  }
}

// mutations
const mutations = {
  UPDATE_KPIS_INTERVAL_STATIONS (state, data) {
    state.kpisIntervalStations = data
  },
  UPDATE_CHARTS_INTERVAL_STATIONS (state, data) {
    state.chartsIntervalStations = data
  },
  UPDATE_CATEGORIES_STATIONS (state, data) {
    console.log('UPDATE_CATEGORIES_STATIONS')
    state.gisDataByCategories = data
  },
  UPDATE_CATEGORY_DISABLED (state, data) {
    state.categoriesDisabled = data
  },
  UPDATE_KPIS_AMBIENTAL_METEO (state, data) {
    state.kpisAmbientalMeteo = data
  },
  UPDATE_CATEGORY_STATION (state, data) {
    state.gisDataByCategories[data.index] = data.info
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardAmbientalMeteo.js